import React from "react";
import { FlexGrid } from "@clearabee/ui-library-native";
import {
  SurchargeSelection,
  SurchargeSelectionProps,
} from "components/SurchargeSelection/SurchargeSelection";
import { ProhibitedItemsPanel } from "./ProhibitedItemsPanel";
import type { CatalogueItem } from "lib/types";
import type { UseTooltipReturn } from "lib/hooks/useTooltip";

interface SurchargesProhibitedItemsProps {
  hasProhibitedItems: boolean;
  hasSurcharges: boolean;

  surchargeItems: UseTooltipReturn["surchargeItems"];
  prohibitedItems: UseTooltipReturn["prohibitedItems"];

  onSurchargeSelection: SurchargeSelectionProps["onSurchargeSelection"];

  surcharges: CatalogueItem[];

  isSkipJob?: boolean;
}

export const SurchargesProhibitedItems = ({
  hasProhibitedItems,
  hasSurcharges,
  surchargeItems,
  prohibitedItems,
  onSurchargeSelection,
  surcharges,
  isSkipJob = false,
}: SurchargesProhibitedItemsProps): React.ReactElement => {
  return (
    <>
      {hasSurcharges && (
        <FlexGrid.Cell base="100%" medium="45%">
          <SurchargeSelection
            surcharges={surcharges}
            extrasTooltip={surchargeItems}
            prohibitedItemsTooltip={prohibitedItems}
            onSurchargeSelection={onSurchargeSelection}
          />
        </FlexGrid.Cell>
      )}
      {(hasSurcharges || hasProhibitedItems) && (
        <FlexGrid.Cell base="100%" medium={hasSurcharges ? "55%" : "100%"}>
          <ProhibitedItemsPanel
            surchargeItems={surchargeItems}
            prohibitedItems={prohibitedItems}
            hasSurcharges={hasSurcharges}
            isSkipJob={isSkipJob}
          />
        </FlexGrid.Cell>
      )}
    </>
  );
};
